import React 			from 'react';
import PropTypes 	from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx';

export default class VideoContent extends BLComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {url, classes = ''} = this.props;
		

		if(blapp.cookie.isCookieEnabled("TFP")) {
			return (
				<div className={`video-container ${classes}`}>
					{url.indexOf('youtube') != -1 || url.indexOf('youtu.be') != -1 ?
						<iframe src={"https://www.youtube.com/embed/" + blapp.util.getYoutubeId(url) + '?autoplay=false'} className="video-container__content" frameBorder="0"  allowFullScreen/>
					: 
						url.indexOf('vimeo') != -1 ? 
							<iframe src={"https://player.vimeo.com/video/" + blapp.util.getVimeoId(url) + '?autoplay=false'} className="video-container__content" frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen/>
						: 
							null
					}
				</div>
			);
		}else{
			return (
				<div className={`video-container video-container--not-allowed ${classes}`}>
					<div className="video-container__content video-container__content--not-allowed">
						<div className="video-container__not-allowed-icon"><i className="far fa-file-video"/></div>
						<div className="video-container__not-allowed-content">To view YouTube/Vimeo content on BrickLink, you must accept third-party marketing cookies.</div>
						<a className="video-container__not-allowed-cta btn btn--wide btn--white" href={blapp.url2.getCookiesPolicyUrl()}>See Cookie Policy and Settings</a>
					</div>				
				</div>
			);
		}
	}
}